module.exports = __webpack_public_path__ + "img/four-points-by-sheraton-sesimbra.c4b9beb4.jpg";